import { cleanNumber, formatAWSDate } from '../../../helpers/functions';
import { CreateStrategyAssetInput, FormValues } from '../types';
import { FormikProps } from 'formik';
import { ConnectionTypeEnum } from '../../../constants/enums';

export function prepareBankInput(
  profileId: string,
  connectionType: ConnectionTypeEnum,
  formik: FormikProps<FormValues>
) {
  const { strategyId } = formik.values;

  const purchasedAt = formatAWSDate(
    formik.values.purchasedAt ? new Date(formik.values.purchasedAt) : new Date()
  );

  const result: CreateStrategyAssetInput[] =
    formik.values.selectedBankAssets.map(
      ({
        bankName,
        currency,
        name,
        price,
        strategyAssetCategoryId,
        quantity: unit,
      }) => ({
        alert: false,
        bank: bankName,
        connectionType,
        currency,
        currentPrice: price,
        entryPrice: price,
        inspirationSource: '',
        name,
        profileId,
        purchasedAt,
        strategyAssetCategoryId,
        strategyAssetTargets: [],
        strategyId,
        unit: cleanNumber(unit.toString()),
      })
    );

  return result;
}
